module.exports = __webpack_public_path__ + "static/img/player_head_3.3693358.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/avatar/user/player_head_3.jpg
// module id = ELur
// module chunks = 1